

const messagebar = state => state.messagebar;
const apisuccess = state => state.apisuccess;
const apierror = state => state.apierror;
const paths = state => state.paths;
const mainlogo = state => state.mainlogo;


export default {
    paths,
    messagebar,
    apisuccess,
    apierror,
    mainlogo
    
};